// Define the game rules for this specific game

import { GameAssets } from "./shared/util/GameAssets";

// Can be re-styled and repurposed for other games
export const getGameRuleHtmlElement: () => HTMLElement = () => {
  const root: HTMLElement = document.createElement("div");

  Object.assign(root.style, {
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    alignItems: "center",
    padding: "20px",
    position: "relative",
    overflowY: "scroll",
    overflowX: "hidden",
    width: "100%",
    height: "100%",
    zIndex: "9998",
  });

  const createHorizontalRuler: () => HTMLElement = () => {
    let horizontalRuler: HTMLElement = document.createElement("hr");

    Object.assign(horizontalRuler.style, {
      // Ensure flex layout won't shrink our hr-s
      flexShrink: "0",
      width: "100%",
      height: "2px",
      background:
        "linear-gradient(to right, #00000000 0%, #555 33%, #555 66%, #00000000 100%)",
      border: "0px",
      zIndex: "9998",
    });

    return horizontalRuler;
  };

  const createHeader: (text: string) => HTMLElement = (text: string) => {
    const header: HTMLElement = document.createElement("h4");

    Object.assign(header.style, {
      display: "block",
      position: "relative",
      margin: "0.25em 0em 0.25em 0em",
      color: "rgb(255, 133, 49)",
      zIndex: "9998",
    });

    header.textContent = text.replace(/\s+/g, " ");

    return header;
  };

  const createParagraph: (text: string) => HTMLElement = (text: string) => {
    const paragraph: HTMLElement = document.createElement("p");

    Object.assign(paragraph.style, {
      display: "block",
      position: "relative",
      fontSize: "0.7em",
      textAlign: "center",
      color: "white",
      zIndex: "9998",
    });

    text = text.trim();
    paragraph.innerHTML = text;

    return paragraph;
  };

  const createBulletList: (
    points: string[],
    showBullets?: boolean,
    padding?: string,
    textAlign?: "left" | "center",
  ) => HTMLElement = (
    points: string[],
    showBullets: boolean = true,
    padding: string = "0",
    textAlign: "left" | "center" = "left",
  ) => {
      const bulletList: HTMLElement = document.createElement("ul");

      Object.assign(bulletList.style, {
        display: "block",
        padding: padding,
        margin: "0",
        position: "relative",
        fontSize: "0.7em",
        listStyleType: showBullets ? "disc" : "none",
        color: "white",
        textAlign: textAlign,
        zIndex: "9998",
      });

      points.forEach((point: string) => {
        const bulletPoint: HTMLElement = document.createElement("li");
        bulletPoint.innerHTML = point;
        bulletList.appendChild(bulletPoint);
      });

      return bulletList;
    };

  const createImage: (
    path: string,
    width?: string,
    height?: string,
    margin?: string,
  ) => HTMLImageElement = (
    path: string,
    width: string = "auto",
    height: string = "6em",
    margin: string = "0",
  ) => {
      const image: HTMLImageElement = document.createElement("img");

      Object.assign(image.style, {
        display: "block",
        position: "relative",
        margin: margin,
        width: width,
        height: height,
        maxWidth: "100%",
        maxHeight: "100%",
        aspectRatio: "auto",
        objectFit: "contain",
        zIndex: "9998",
      });

      image.src = path;

      return image;
    };

  // const createGrid: (
  //   elements: HTMLElement[],
  //   rows: number,
  //   columns: number,
  // ) => HTMLElement = (
  //   elements: HTMLElement[],
  //   rows: number,
  //   columns: number,
  // ) => {
  //   const grid: HTMLElement = document.createElement("div");

  //   Object.assign(grid.style, {
  //     display: "grid",
  //     justifyContent: "center",
  //     gap: "0px",
  //     gridTemplateRows: `repeat(${rows}, 1fr)`,
  //     gridTemplateColumns: `repeat(${columns}, 1fr)`,
  //     position: "relative",
  //     zIndex: "9998",
  //   });

  //   elements.forEach((element: HTMLElement) => {
  //     grid.appendChild(element);
  //   });

  //   return grid;
  // };

  const createHorizontalElementSequence: (
    elements: HTMLElement[],
    width: string,
    elementWidth: string,
  ) => HTMLElement = (
    elements: HTMLElement[],
    width: string,
    elementWidth: string,
  ) => {
      const container: HTMLElement = document.createElement("div");

      Object.assign(container.style, {
        display: "flex",
        width: width,
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "baseline",
        position: "relative",
        zIndex: "9998",
      });

      elements.forEach((element: HTMLElement) => {
        Object.assign(element.style, {
          width: elementWidth,
        });
        container.appendChild(element);
      });

      return container;
    };

  const createCard: (elements: HTMLElement[]) => HTMLElement = (
    elements: HTMLElement[],
  ) => {
    const card: HTMLElement = document.createElement("div");

    Object.assign(card.style, {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      position: "relative",
      boxSizing: "border-box",
      zIndex: "9998",
      margin: "0.5em", // Add margin between cards
    });

    elements.forEach((element: HTMLElement) => {
      card.appendChild(element);
    });

    return card;
  };

  root.appendChild(createHorizontalRuler());
  root.appendChild(createHeader("Paytable"));
  root.appendChild(
    createParagraph(
      `Rising Cup is a classic 5x3 video slot with 10 Bet lines.<br>
        The maximum win is 1000x bet!`,
    ),
  );

  root.appendChild(createHorizontalRuler());
  root.appendChild(createHeader("Wild Symbol"));
  root.appendChild(createImage(GameAssets.textures.wildsDemo.label));
  root.appendChild(
    createParagraph(
      `Wild symbol can appear on reels 2, 3, 4, and they always expand.<br>`,
    ),
  );

  root.appendChild(createHorizontalRuler());
  root.appendChild(createHeader("Symbols Pay (EUR)"));
  root.appendChild(createHorizontalRuler());
  root.appendChild(createHeader("Scatter Symbols"));
  root.appendChild(
    createHorizontalElementSequence(
      [
        createCard([
          createImage(
            GameAssets.textures.dollarSymbol.label,
            "100%",
            "5em",
            "0.2em",
          ),
          createBulletList(
            [
              "5: <span style='color: orange'>100</span>",
              "4: <span style='color: orange'>20</span>",
              "3: <span style='color: orange'>5</span>",
            ],
            false,
          ),
        ]),
        createCard([
          createImage(
            GameAssets.textures.starSymbol.label,
            "100%",
            "5em",
            "0.2em",
          ),
          createBulletList(
            [
              "1st, 3rd, and 5th reels:",
              "3: <span style='color: orange'>20</span>",
            ],
            false,
          ),
        ]),
      ],
      "100%",
      "25%",
    ),
  );
  root.appendChild(
    createHorizontalElementSequence(
      [
        createCard([
          createImage(
            GameAssets.textures.sevenSymbol.label,
            "100%",
            "5em",
            "0.2em",
          ),
          createBulletList(
            [
              "5: <span style='color: orange'>500</span>",
              "4: <span style='color: orange'>25</span>",
              "3: <span style='color: orange'>5</span>",
              "2: <span style='color: orange'>1</span>",
            ],
            false,
          ),
        ]),
      ],
      "100%",
      "25%",
    ),
  );
  root.appendChild(
    createHorizontalElementSequence(
      [
        createCard([
          createImage(
            GameAssets.textures.grapesSymbol.label,
            "100%",
            "5em",
            "0.2em",
          ),
          createBulletList(
            [
              "5: <span style='color: orange'>70</span>",
              "4: <span style='color: orange'>12</span>",
              "3: <span style='color: orange'>4</span>",
            ],
            false,
          ),
        ]),
        createCard([
          createImage(
            GameAssets.textures.watermelonSymbol.label,
            "100%",
            "5em",
            "0.2em",
          ),
          createBulletList(
            [
              "5: <span style='color: orange'>70</span>",
              "4: <span style='color: orange'>12</span>",
              "3: <span style='color: orange'>4</span>",
            ],
            false,
          ),
        ]),
        createCard([
          createImage(
            GameAssets.textures.bellSymbol.label,
            "100%",
            "5em",
            "0.2em",
          ),
          createBulletList(
            [
              "5: <span style='color: orange'>20</span>",
              "4: <span style='color: orange'>4</span>",
              "3: <span style='color: orange'>2</span>",
            ],
            false,
          ),
        ]),
      ],
      "100%",
      "25%",
    ),
  );
  root.appendChild(
    createHorizontalElementSequence(
      [

        createCard([
          createImage(
            GameAssets.textures.plumSymbol.label,
            "100%",
            "5em",
            "0.2em",
          ),
          createBulletList(
            [
              "5: <span style='color: orange'>15</span>",
              "4: <span style='color: orange'>3</span>",
              "3: <span style='color: orange'>1</span>",
            ],
            false,
          ),
        ]),
        createCard([
          createImage(
            GameAssets.textures.orangeSymbol.label,
            "100%",
            "5em",
            "0.2em",
          ),
          createBulletList(
            [
              "5: <span style='color: orange'>15</span>",
              "4: <span style='color: orange'>3</span>",
              "3: <span style='color: orange'>1</span>",
            ],
            false,
          ),
        ]),
      ],
      "100%",
      "25%",
    ),
  );
  root.appendChild(
    createHorizontalElementSequence(
      [

        createCard([
          createImage(
            GameAssets.textures.lemonSymbol.label,
            "100%",
            "5em",
            "0.2em",
          ),
          createBulletList(
            [
              "5: <span style='color: orange'>15</span>",
              "4: <span style='color: orange'>3</span>",
              "3: <span style='color: orange'>1</span>",
            ],
            false,
          ),
        ]),
        createCard([
          createImage(
            GameAssets.textures.cherrySymbol.label,
            "100%",
            "5em",
            "0.2em",
          ),
          createBulletList(
            [
              "5: <span style='color: orange'>15</span>",
              "4: <span style='color: orange'>3</span>",
              "3: <span style='color: orange'>1</span>",
            ],
            false,
          ),
        ]),
      ],
      "100%",
      "25%",
    ),
  );
  root.appendChild(
    createParagraph("A symbol's pay reflects current bet configuration."),
  );

  root.appendChild(createHorizontalRuler());
  root.appendChild(createHeader("Bet Lines"));
  root.appendChild(
    createImage(GameAssets.textures.betwaysDemo.label, "100%", "8em"),
  );
  root.appendChild(
    createParagraph(
      `Winning combinations are formed from left to right on adjacent reels, beginning from the leftmost reel.\n<br>
        Only the highest winning combination is paid per line.`,
    ),
  );

  
  // rgb(255, 133, 49) orange
  root.appendChild(createHorizontalRuler());
  root.appendChild(
    createCard([
      createImage(
        GameAssets.textures.spinButtonNew.label,
        "auto",
        "3em",
        "0.5em",
      ),
      createBulletList(["Spin button."], false, "0", "center"),
    ]),
  );
  root.appendChild(createHorizontalRuler());
  root.appendChild(
    createCard([
      createImage(
        GameAssets.textures.buyButtonNew.label,
        "auto",
        "3em",
        "0.5em",
      ),
      createBulletList(["Cheat button."], false, "0", "center"),
    ]),
  );
  root.appendChild(createHorizontalRuler());
  root.appendChild(
    createCard([
      createImage(
        GameAssets.textures.soundButtonOn.label,
        "auto",
        "3em",
        "0.5em",
      ),
      createBulletList(["Sound toggle on/off."], false, "0", "center"),
    ]),
  );
  root.appendChild(createHorizontalRuler());
  root.appendChild(
    createCard([
      createImage(
        GameAssets.textures.autoplayButton.label,
        "auto",
        "3em",
        "0.5em",
      ),
      createBulletList(
        ["Allows specifying the amount of times autoplay will be executed."],
        false,
        "0",
        "center",
      ),
    ]),
  );
  root.appendChild(createHorizontalRuler());
  root.appendChild(
    createCard([
      createImage(
        GameAssets.textures.fastButtonOn.label,
        "auto",
        "3em",
        "0.5em",
      ),
      createBulletList(["Makes the spins faster."], false, "0", "center"),
    ]),
  );
  root.appendChild(createHorizontalRuler());
  root.appendChild(
    createCard([
      createImage(GameAssets.textures.betDemo.label, "auto", "2em", "0.5em"),
      createBulletList(
        [
          "Allows setting a custom bet amount. Cannot be changed during a spin. Max bet allowed is 100 EUR.",
        ],
        false,
        "0",
        "center",
      ),
    ]),
  );

  root.appendChild(createHorizontalRuler());
  root.appendChild(createHeader("Rules & Information"));
  root.appendChild(
    createBulletList(
      [
        "The theoretical pay-out (RTP) is 96.08% and maximum win is 1000x bet.",
        "Bets are made in the casino currency, and there are 15 bet levels.",
        "The bet level cannot be changed during a game round.",
        "All wins are displayed and paid in the casino currency in accordance with the paytable.",
        "If a game round is interrupted, all information and bets will be displayed when the game is relaunched",
        "Wins from uninterrupted game rounds may be forfeited if they are not claimed within a certain period. Please see operator specific terms and conditions for details",
        "Malfunction voids all plays and pays",
      ],
      true,
      "1em",
    ),
  );

  return root;
};
